/**
 * Access token key name in local storage
 * @type {string}
 */
export const ACCESS_TOKEN_KEY = 'accessToken';

/**
 * Logged in user key name in local storage
 * @type {string}
 */
export const LOGGED_IN_USER_KEY = 'loggedInUser';

/**
 * Backend url for openapi
 * @type {string}
 */
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Parking VPN proxy (live entries/exits view, /beweb/api/*)
 * @type {string}
 */
export const PARKING_PROXY_URL =
    process.env.REACT_APP_PARKING_PROXY_URL || 'https://parking-proxy.lurdyhaz.hu';

/**
 * Camera images of the passages (Cloudflare in front of the B2 bucket), <url>/<img object name of the event>
 * @type {string}
 */
export const PARKING_IMG_URL =
    process.env.REACT_APP_PARKING_IMG_URL || 'https://parking-img.lurdyhaz.hu';

/**
 * Test text for test site only
 * @type {number}
 */
export const TEST_LABEL_ENABLED = process.env.REACT_APP_TEST_LABEL_ENABLED === '1';
